<template>
  <div class="row">
    <LoadingContentPanel :isLoadShow="isLoadShow"/>
    <CreateOrderList v-if="type === 'ordercreate'"></CreateOrderList>
    <OrderList v-if="type === 'orderlist'" :userId="this.$store.state.userId" userType="customer"></OrderList>
    <CurrentOrder v-if="type === 'orderinfo'" :userId="this.$store.state.userId" userType="customer" :orderId="this.routeInfo.id"></CurrentOrder>
    <TimeInfo v-if="type === 'time'" :userId="this.$store.state.userId" category="customer" :orderId="this.routeInfo.id" parentType="customer"></TimeInfo>
    <UpdateUserInfo v-if="type === 'profile'" :userId="this.$store.state.userId" userType="customer"></UpdateUserInfo>
    <OrderScore v-if="type === 'orderscore'" :userId="this.$store.state.userId" userType="customer" :orderId="this.routeInfo.id"></OrderScore>
    <OrderTransferCode v-if="type === 'transfercode'" :userId="this.$store.state.userId" userType="customer" :orderId="this.routeInfo.id"></OrderTransferCode>
    <AccountInfo v-if="type === 'account'" :userId="this.$store.state.userId" userType="customer"></AccountInfo>
    <TransferProfile v-if="type === 'transferprofile'" :userId="this.$store.state.userId" userType="customer"></TransferProfile>
    <TransferPlanPage v-if="type === 'transferplan'" :userId="this.$store.state.userId" userType="customer" :planInfo="planObj"></TransferPlanPage>
    <TransferCodeConfirm v-if="type === 'transferplancode'" :userId="this.$store.state.userId" userType="customer"></TransferCodeConfirm>
  </div>
</template>
<script>
import CreateOrderList from '@/components/CreateOrderList.vue'
import LoadingContentPanel from '@/components/utils/LoadingContentPanel.vue'
import OrderList from '@/components/OrderList.vue'
import CurrentOrder from '@/components/CurrentOrder.vue'
import TimeInfo from '@/components/TimeInfo.vue'
import UpdateUserInfo from '@/components/UpdateUserInfo.vue'
import OrderScore from '@/components/customer/OrderScore.vue'
import OrderTransferCode from '@/components/customer/OrderTransferCode.vue'
import AccountInfo from '@/components/AccountInfo.vue'
import TransferProfile from '@/components/customer/transfer/TransferProfile.vue'
import TransferPlanPage from '@/components/customer/transfer/TransferPlanPage.vue'
import TransferCodeConfirm from '@/components/customer/transfer/TransferCodeConfirm.vue'

export default {
  name: 'CustomerView',
  data () {
    return {
      routeInfo: {
        type: '',
        category: '',
        case: '',
        id: ''
      },
      isLoadShow: true,
      isCreateList: false,
      isList: false,
      isTimeInfo: false,
      isCurrentOrder: false,
      isProfile: false,
      type: 'default',
      // id info
      planObj: {}
    }
  },
  created () {
    this.$nextTick(() => {
      this.updateRender()
    })
  },
  watch: {
    '$store.state.userId' () {
      this.updateRender()
    }
  },
  methods: {
    checkRenderCategoryPanel () {
      switch (this.routeInfo.category) {
        case 'profile':
          this.isLoadShow = false
          switch (this.routeInfo.case) {
            case 'update':
              this.type = 'profile'
              break
          }
          break
        case 'orders':
          this.checkOrderCase()
          break
        case 'account':
          this.checkAccountCase()
          break
        case 'transfer':
          this.checkTransferCase()
          break
        default:
          this.isLoadShow = true
          // this.isCreateList = false
          // this.isList = false
          // this.isCurrentOrder = false
          this.type = 'default'
      }
      this.$forceUpdate()
    },
    checkOrderCase () {
      switch (this.routeInfo.case) {
        case 'create':
          this.isLoadShow = false
          // this.isCreateList = true
          // this.isList = false
          // this.isCurrentOrder = false
          this.type = 'ordercreate'
          break
        case 'list':
          this.isLoadShow = false
          // this.isCreateList = false
          // this.isList = true
          // this.isCurrentOrder = false
          this.type = 'orderlist'
          break
        case 'info':
          this.isLoadShow = false
          // this.isList = false
          // this.isCreateList = false
          // this.isCurrentOrder = true
          this.type = 'orderinfo'
          break
        case 'time':
          this.isLoadShow = false
          // this.isCreateList = false
          // this.isList = false
          // this.isCurrentOrder = false
          // this.isTimeInfo = true
          this.type = 'time'
          break
        case 'score':
          this.isLoadShow = false
          this.type = 'orderscore'
          break
        case 'transfercode':
          this.isLoadShow = false
          this.type = 'transfercode'
          break
      }
    },
    checkAccountCase () {
      switch (this.routeInfo.case) {
        case 'customer':
        case 'staff':
          this.isLoadShow = false
          this.type = 'account'
          break
      }
    },
    checkTransferCase () {
      switch (this.routeInfo.case) {
        case 'plan':
          console.log(this.routeInfo.id)
          var idString = this.$tool.decodeString(this.routeInfo.id)
          var idObj
          if (idString) {
            idObj = JSON.parse(idString)
            this.planObj.orderId = idObj.order_id
            this.planObj.cash = idObj.cash
          }
          this.type = 'transferplan'
          break
        case 'profile':
          this.type = 'transferprofile'
          break
        case 'transfercode':
          this.type = 'transferplancode'
      }
    },
    updateRender () {
      const userId = this.$store.state.userId
      const currentFpt = this.$route.fullPath
      var tranPtArray = currentFpt.split('/').slice(1) // eg. ['staff', 'order', 'create']
      var currenRouteInfo = this.$store.getters.getRouteInfo
      var caseIdArray = []
      if (userId !== '' && userId !== undefined && userId !== null) {
        if (tranPtArray[2]) {
          tranPtArray[2] = tranPtArray[2].includes('?v') ? tranPtArray[2].split('?v').shift() : tranPtArray[2]
        }
        if ((tranPtArray.length > 2 && (currenRouteInfo.category !== tranPtArray[1] || currenRouteInfo.case !== tranPtArray[2]))) {
          this.routeInfo.type = tranPtArray[0].includes('?') ? tranPtArray[0].split('?').shift() : tranPtArray[0]
          this.routeInfo.category = tranPtArray[1]
          if (tranPtArray[2] && tranPtArray[2].includes('#')) {
            caseIdArray = tranPtArray[2].split('#')
            this.routeInfo.case = caseIdArray[0]
            this.routeInfo.id = caseIdArray[1]
          } else {
            this.routeInfo.case = tranPtArray[2]
          }
          this.$store.dispatch('setRouteInfo', this.routeInfo)
        } else {
          this.routeInfo = currenRouteInfo
        }
        this.checkRenderCategoryPanel()
      }
    }
  },
  components: {
    CreateOrderList,
    LoadingContentPanel,
    OrderList,
    CurrentOrder,
    TimeInfo,
    UpdateUserInfo,
    OrderScore,
    OrderTransferCode,
    AccountInfo,
    TransferProfile,
    TransferPlanPage,
    TransferCodeConfirm
  }
}
</script>
